import { CadastreOwnership as ApiOwnership } from '../realty/model/CadastreOwnership';
import { CadastreHousingValue as ApiHousingValue } from '../realty/model/CadastreHousingValue';
import { Cadastre as ApiCadastre } from '../realty/model/Cadastre';
import { Building as ApiBuilding } from '../realty/model/Building';
import { Affair as ApiAffair } from '../realty/model/Affair';
import { Cadastre } from './Cadastre';
import { Affair } from './Affair';
import { equal, firstDatePrecedesSecond, defined, evaluate } from '../utility/Control';
import { Building } from './Building';
import { HousingValue } from './HousingValue';
import { Person } from '../realty/model/Person';
import { Ownership } from './Ownership';
import { ApiDate } from '../realty/model/ApiDate';
import { Response } from '../realty/model/Response';
import { Info } from '../realty/model/Info';
import { CadastreAffair } from '../realty/model/CadastreAffair';
import Debugger from '../utility/Debugger';

export class Report {
  public isPresentable = true;
  public info: Info;
  public cadastre: Cadastre;
  public affairs: Affair[] = [];
  public buildings: Building[] = [];
  public housingValue: HousingValue;
  public surroundingHousingValues: HousingValue[] = [];
  public sumPledge: number;
  public ownerships: Ownership[] = [];

  public constructor(validateCadastreResponse: Response) {
    Debugger.print('Constructing report from the following object:');
    Debugger.print(validateCadastreResponse);
    this.info = evaluate(validateCadastreResponse, 'info');
    const apiCadastre: ApiCadastre = evaluate(validateCadastreResponse, 'item.inclusions.cadastre.item');
    if (defined(apiCadastre)) {
      this.cadastre = new Cadastre(apiCadastre);
      const apiBuildings: ApiBuilding[] = evaluate(apiCadastre, 'inclusions.buildings.items');
      if (defined(apiBuildings)) {
        this.buildings = apiBuildings.map((apiBuilding: ApiBuilding) => new Building(apiBuilding));
      }
      const apiHousingValue: ApiHousingValue = evaluate(apiCadastre, 'inclusions.housingValue.item');
      if (defined(apiHousingValue)) {
        this.housingValue = new HousingValue(apiHousingValue);
      }
      const apiHousingValues: ApiHousingValue[] = evaluate(apiCadastre, 'inclusions.surroundingHousingValues.items');
      if (defined(apiHousingValues)) {
        const housingValues: HousingValue[] = apiHousingValues.map(
          (value: ApiHousingValue) => new HousingValue(value)
        );
        this.surroundingHousingValues = housingValues.filter((housingValue: HousingValue) =>
          defined(housingValue.calculatedValue)
        );
      }
      this.sumPledge = evaluate(apiCadastre, 'inclusions.liensCalculation.item.pledge.sumPledge');
      this.extractOwnerships(evaluate(apiCadastre, 'inclusions.ownershipsOwningThisCadastre.items'));
      const apiAffairs: ApiAffair[] = evaluate(apiCadastre, 'inclusions.affairs.items');
      const dateOfMostRecentFreeMarketConveyance: ApiDate = evaluate(
        this.housingValue,
        'mostRecentFreeMarketConveyance.dateRegistered'
      );
      this.extractAffairsAfterDate(apiAffairs, dateOfMostRecentFreeMarketConveyance);
    } else {
      this.isPresentable = false;
    }
  }

  private extractAffairsAfterDate(apiAffairs: ApiAffair[], date: ApiDate): void {
    if (defined(apiAffairs, date)) {
      apiAffairs.forEach((apiAffair: ApiAffair) => {
        const affairDocumentDate: ApiDate = apiAffair.affairDocumentDate;
        const cadastreAffairs: CadastreAffair[] = apiAffair.cadastreAffairs;
        if (defined(affairDocumentDate, cadastreAffairs) && firstDatePrecedesSecond(date, affairDocumentDate)) {
          cadastreAffairs.forEach((apiCadastreAffair: CadastreAffair) => {
            if (equal(this.cadastre.ident, apiCadastreAffair.cadastreIdent) && apiCadastreAffair.area !== 0) {
              this.affairs.push(new Affair(apiCadastreAffair, affairDocumentDate));
            }
          });
        }
      });
    }
  }

  private extractOwnerships(apiOwnerships: ApiOwnership[]): void {
    if (defined(apiOwnerships)) {
      this.ownerships = apiOwnerships.map((apiOwnership: ApiOwnership) => {
        const owningPerson: Person = evaluate(apiOwnership, 'inclusions.owningPerson.item');
        const dateRegistered = evaluate(apiOwnership, 'inclusions.conveyance.item.dateRegistered');
        return new Ownership(owningPerson, dateRegistered, apiOwnership.fraction);
      });
    }
  }
}



/** WEBPACK FOOTER **
 ** ./src/model/Report.ts
 **/